export default __webpack_public_path__ + "bb7466298c4500773503ad23b58c2e0a.png";